module.exports = __webpack_public_path__ + "img/logo-Récupéré.a6fbe2d3.png";